import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    data: [],
    locationId: '',
    shiftReleaseOderList: [],
    shiftReleaseOderWaitTimeList: [],
    savedJobShiftReleaseOrderIds: [],
    jobPostedData: {},
    masterData: {
        statusList: [],
        matchingCriteriaList: [],
        travelDistanceList: [],
        newStatusList: [],
    },
    jobInfo: [],
    params: {
        "page": 1,
        "pageSize": 25,
        "sortOrder": "",
        "sortColumn": "",
        "distance": "50",
        "matchingCriteria": null,
        "searchStatus": [{ id: 98, name: "All" }],
        "SearchText": "",
        "jobShiftUniqueId": "",
        "IsBestMatch": false,
        "jobsClaimId": '',
        "candidateTeamId": '0'
    },
    error: false,
    errorMessage: null,
    dropDownJobId: 0,
    filterControls: [],
    loadingFlag: 0,
    totalCount: 0,
    depsUnits:[],
    isDataNotFound:false,
    sortOrderType:{id:null, type:null}
}

export const matchingCandidateSlice = createSlice({
    name: 'matchingCandidateInfo',
    initialState,
    reducers: {
        setMatchingCandidateInfo: (state, action) => {
            state.data = action.payload;
        },
        setMasterData: (state, action) => {
            if (action.payload.status) {
                state.masterData.statusList = action.payload.status;
            }
            if (action.payload.criteria) {
                state.masterData.matchingCriteriaList = action.payload.criteria;
            }
            if (action.payload.travelDistance) {
                state.masterData.travelDistanceList = action.payload.travelDistance;
            }
            if (action.payload.newstatus) {
                state.masterData.newStatusList = action.payload.newstatus;
            }
        },
        setError: (state, action) => {
            state.error = true;
            state.errorMessage = action.payload;
        },
        resetError: (state) => {
            state.error = false;
            state.errorMessage = null;
        },
        setParams: (state, action) => {
            state.params = action.payload;
        },
        resetParams: (state) => {
            state.params = {
                "page": 1,
                "pageSize": 25,
                "sortOrder": "",
                "sortColumn": "",
                "distance": "5",
                "matchingCriteria": '',
                "searchStatus": [{ id: 3, name: "Authorized" }],
                "SearchText": "",
                "jobUniqueId": "",
                "IsBestMatch": false,
                "jobsClaimId": '',
                "candidateTeamId": '0'
            };
        },
        setLocationId: (state, action) => {
            state.locationId = action.payload
        },
        setJobInfo: (state, action) => {
            state.jobInfo = action.payload
        },
        setshiftReleaseOderList: (state, action) => {
            state.shiftReleaseOderList = action.payload
        },
        setshiftReleaseOderWaitTimeList: (state, action) => {
            state.shiftReleaseOderWaitTimeList = action.payload
        },
        setSavedJobShiftReleaseOrderIds: (state, action) => {
            state.savedJobShiftReleaseOrderIds = action.payload;
        },
        setJobPostedData: (state, action) => {
            state.jobPostedData = action.payload
        },
        setDropdownJobId: (state, action) => {
            state.dropDownJobId = action.payload
        },
        setFilterControls: (state, action) => {
            state.filterControls = action.payload
        },
        reset: () => initialState,
        setLodingFlagIncrement: (state) => {
            state.loadingFlag = state.loadingFlag + 1
        },
        setLodingFlagDecrement: (state) => {
            if (state.loadingFlag !== 0) {
                state.loadingFlag = state.loadingFlag - 1
            }
        },
        setTotalCount: (state, action) => {
            state.totalCount = action.payload;
        },
        setValue:(state,{payload}) => {
            state[payload?.name] = payload?.value
        },
        setIsDataNotFound:(state,{payload}) => {
            state.isDataNotFound = payload
        },
        setSortOrderType:(state,{payload}) => {
            state.sortOrderType = payload;
        }
    }
});

export const { setMatchingCandidateInfo, setMasterData, setError, resetError, setParams, resetParams,
    setLocationId, setJobInfo, setshiftReleaseOderList, setshiftReleaseOderWaitTimeList,
    setSavedJobShiftReleaseOrderIds, setJobPostedData, reset, setDropdownJobId, setFilterControls,
    setLodingFlagIncrement, setLodingFlagDecrement, setTotalCount,setValue,setIsDataNotFound,setSortOrderType
} = matchingCandidateSlice.actions;

export default matchingCandidateSlice.reducer;